// extracted by mini-css-extract-plugin
export default {"landPage_section5_div1":"carousel_landPage_section5_div1__Cbmh2","Carousel_btn":"carousel_Carousel_btn__l7gqo","Carousel":"carousel_Carousel__8yh03"};